/* ============================================================
   Flaire review asset loader

   PERF FIX C (Sep 2026)
   Before: this file was injected into <head> with Liquid's script_tag filter,
   i.e. a RENDER-BLOCKING <script src> with no defer, on EVERY page of the
   store. It then chain-loaded 12 more scripts (9 review data files + 3
   interface files, ~160KB) with async=false, so they executed serially on the
   main thread. flaire-live-v1.js alone was measured at 43.7s of main-thread
   time on the product page.

   After:
   1. theme.liquid loads this file with defer, so it never blocks first paint.
   2. It returns immediately unless a Judge.me review widget is actually on the
      page.
   3. Even then it waits until the widget is within 600px of the viewport
      before pulling the 12 dependent files.

   v2 fix: the original version watched the widget node with an
   IntersectionObserver — but Judge.me REPLACES that node when it installs,
   so the observer held a detached element and never fired, and the review
   interface never loaded. The trigger is now a rect check that re-queries
   the live node every time.

   NOTE: `build` doubles as the cache-buster for the chain-loaded files.
   Bump it whenever flaire-live-v1.js / flaire-rev-css.js /
   flaire-review-gallery.js change, or browsers keep the old bundle.
   ============================================================ */
(function () {
  if (window.__frReviewAssetsLoading || window.__frReviewAssetsLoaded) return;

  var current = document.currentScript;
  var base = current && current.src
    ? current.src.replace(/[?#].*$/, "").replace(/[^/]*$/, "")
    : "";
  var version = current && current.src && current.src.indexOf("?") !== -1
    ? current.src.slice(current.src.indexOf("?"))
    : "";
  var build = "12";
  var WIDGET_SELECTOR = "#judgeme_product_reviews, .jdgm-review-widget, [data-fr-reviews]";

  var dataFiles = [
    "flaire-photos-1.js",
    "flaire-photos-2.js",
    "flaire-photos-3.js",
    "flaire-revs-1.js",
    "flaire-revs-2.js",
    "flaire-revs-3.js",
    "flaire-revs-4.js",
    "flaire-revs-5.js",
    "flaire-revs-6.js"
  ];
  var interfaceFiles = [
    "flaire-rev-css.js",
    "flaire-live-v1.js",
    "flaire-review-gallery.js"
  ];

  function addScript(filename) {
    return new Promise(function (resolve) {
      var script = document.createElement("script");
      script.src = base + filename + version + (version ? "&" : "?") + "fr=" + build;
      script.async = false;
      script.onload = resolve;
      script.onerror = resolve;
      (document.head || document.documentElement).appendChild(script);
    });
  }

  function loadAll() {
    if (window.__frReviewAssetsLoading || window.__frReviewAssetsLoaded) return;
    window.__frReviewAssetsLoading = true;

    Promise.all(dataFiles.map(addScript)).then(function () {
      return interfaceFiles.reduce(function (chain, filename) {
        return chain.then(function () { return addScript(filename); });
      }, Promise.resolve());
    }).then(function () {
      window.__frReviewAssetsLoading = false;
      window.__frReviewAssetsLoaded = true;
      document.dispatchEvent(new CustomEvent("flaire:reviews-ready"));
    });
  }

  /* Re-query on every check: Judge.me swaps the widget node when it installs,
     so any reference held from an earlier tick can be a detached element. */
  function near() {
    var w = document.querySelector(WIDGET_SELECTOR);
    if (!w) return false;
    var r = w.getBoundingClientRect();
    if (r.width === 0 && r.height === 0 && r.top === 0) return false; /* detached/hidden */
    return r.top < window.innerHeight + 600 && r.bottom > -600;
  }

  function init() {
    if (near()) { loadAll(); return; }

    var debounce = null, ticks = 0;
    function teardown() {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
      if (poll) clearInterval(poll);
    }
    function fire() { teardown(); loadAll(); }
    function check() {
      if (debounce) return;
      debounce = setTimeout(function () {
        debounce = null;
        if (near()) fire();
      }, 180);
    }
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    /* safety net for widgets injected without any scroll (short pages),
       stops itself once the page clearly has no review widget */
    var poll = setInterval(function () {
      ticks++;
      if (near()) { fire(); return; }
      if (ticks > 20 && !document.querySelector(WIDGET_SELECTOR)) teardown();
      if (ticks > 400) teardown();
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();